// Webpack build: require.context keys are relative to ./locales (e.g. ./en-US/app.json).
export default require.context('./locales', true, /\.json$/).keys();
